import React from "react"
import Translation from "components/Translation"
import { StyledLabel } from "./style"

type BaseFieldLabelProps = {
  required?: boolean
  invalid?: boolean
  label?: string
  name: string
  disabled?: boolean
  isFocused?: boolean
}

const FormLabel = ({
  required,
  label,
  name,
  isFocused = false,
  invalid = false,
  disabled = false,
}: BaseFieldLabelProps) => (
  <>
    {label && (
      <StyledLabel htmlFor={name} disabled={disabled} isFocused={isFocused} hasError={invalid}>
        <>
          <Translation label={label} />
          {!required && (
            <>
              {" "}
              (<Translation label="input.optional" />)
            </>
          )}
        </>
      </StyledLabel>
    )}
  </>
)

export default FormLabel
